<script lang="ts" setup>
import type { SancareTogglePositionLabel } from '@sancare-commons/components/types'

withDefaults(defineProps<{
  disabled?: boolean
  label?: string
  labelPosition?: SancareTogglePositionLabel
  name?: string
  id?: string
}>(), {
  disabled: false,
  label: null,
  labelPosition: 'left',
  value: false,
  name: '',
  id: ''
})

const value = defineModel<boolean>('value', { default: false })

function handleClick() {
  value.value = !value.value
  emit('toggle-change', value.value)
}

const emit = defineEmits(['toggle-change'])
</script>

<template>
  <label class="d-flex toggle-switch">
    <span
      v-if="label && labelPosition === 'left'"
      class="me-1"
    >
      {{ label }}
    </span>
    <input
      :id="id !== '' ? id : null"
      :checked="value"
      :disabled="disabled"
      type="checkbox"
      :name="name !== '' ? name: null"
      @click="handleClick()"
    >
    <span class="toggle-switch__switch-container" />
    <span
      v-if="label && labelPosition === 'right'"
      class="ms-1"
    >
      {{ label }}
    </span>
  </label>
</template>
